<template>
  <md-card
    :id="'batch-card-' + cardType + '-' + index"
    class="batch-card"
    :class="'batch-card-' + cardType"
  >
    <md-card-header :id="'card-' + cardType + '-' + index">
      <md-card-header-text>
        <batch-card-header
          :barcode="batch.barcode"
          :index="index"
          :total-samples="batch.total_samples"
          :batch-state="batch.state"
          :label="batch.label"
          :sequence="batch.sequence"
          :creation-date="batch.created_at"
          :collection-place-name="batch.collectionPoint"
        />
        <div class="batch-card__icons-wrap">
          <batch-card-packaging-icon
            :index="index"
            :packaging-id="batch.packagingId"
          />
          <CardAdditionalInformationIcon
            v-if="batch.urgent"
            type="urgent"
            :index="index"
          />
        </div>
      </md-card-header-text>
    </md-card-header>

    <hr :id="'batch-card-hr-' + index">

    <div class="batch-card-icons-container">
      <batch-card-show-details
        v-if="!batch.isPrinted"
        :id="batchesCurrentTab === 'aol20' ? batch.id : batch.barcode"
        :index="index"
        :is-details-mode="isDetailsMode"
      />

      <document-icon
        v-if="batch.docRequired"
        :is-document-delivered="batch.doc_delivered"
        @click.native="pushToDocumentPendings()"
      />
    </div>

    <md-card-content :id="'batch-card-general-status-' + index">
      <batch-card-body
        v-if="!batch.isPrinted"
        :total-samples="batch.total_samples"
        :batch-state="batch.state"
      />
    </md-card-content>

    <md-card-actions
      v-if="buttonsVisible"
      :id="'batch-card-actions-' + index"
    >
      <batch-card-actions
        :batch="batch"
        :index="index"
      />
    </md-card-actions>

    <batch-card-sort-combo
      v-if="!isDetailsMode && !batch.isPrinted"
      :label-selected="batch.printSortSelected.label"
      :index="index"
      :show-hide="batch.printSortShowOff"
    />
  </md-card>
</template>

<script>
import mixin from './../BatchesMixin'
import CardHeader from './Components/CardHeader'
import CardPackagingIcon from './Components/CardPackagingIcon'
import CardShowDetails from './Components/CardShowDetails'
import CardBody from './Components/CardBody'
import CardSortCombo from './Components/CardSortCombo'
import CardActions from './Components/CardActions'
import CardSource from './Components/CardSource'
import CardAdditionalInformationIcon from './Components/CardAdditionalInformationIcon'
import { mapGetters } from 'vuex'

export default {
  name: 'BatchCard',
  components: {
    'batch-card-header': CardHeader,
    'batch-card-packaging-icon': CardPackagingIcon,
    'batch-card-show-details': CardShowDetails,
    'batch-card-body': CardBody,
    'batch-card-sort-combo': CardSortCombo,
    'batch-card-actions': CardActions,
    'batch-card-source': CardSource,
    CardAdditionalInformationIcon
  },
  mixins: [mixin],
  props: {
    batch: {
      type: Object
    },
    isDetailsMode: {
      type: Boolean
    },
    eyeIconVisible: {
      type: Boolean,
      default: true
    },
    buttonsVisible: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    cardType: function () {
      return this.batch.isPrinted ? 'printed' : 'unprinted'
    },
    ...mapGetters(['batchesCurrentTab', 'profile'])
  },
  methods: {
    pushToDocumentPendings() {
      this.$router.push('/documentos-obrigatorios')
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Lote',
        action: 'Filtrar amostras do lote com documentos pendentes',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../../../static/stylesheets/variables';
  .md-dialog {
    .batch-card-show-details {
      display: none;
    }
  }
  .batch-card {
    background-color: #fff;
    box-shadow: none;
    border-radius: 6px;
    display: flex;
    max-height: 431px;
    padding: 18px 15px;
    overflow: visible;
    transition: all 0.5s ease-out;
    width: 100%;
    z-index: auto;
    max-width: 18em;
    min-width: 252px;
    margin: 0 auto;

    &-unprinted {
      min-height: 25.5rem;
    }

    &-printed {
      min-height: 19.5rem;
    }

    &-icons-container {
      display: flex;
    }

    &__icons-wrap {
      display: flex;
      flex-direction: column;
    }

    .document-flag-container {
      margin: 0.2em 0 0 auto;
    }

    hr {
      margin-top: 0.8em;
      background-color: #7a7a7a;
      height: 0.11em;
      border: 0;
      opacity: 0.9;
    }

    .md-card {
      &-actions {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 0px;
      }

      &-header {
        display: flex;
        padding: 0;

        .md-card-media {
          display: flex;
          flex: 0;
          justify-content: center;
          top: 12px;
        }
        @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
          /* IE10+ */
          .md-card-media {
            flex: 0 0 auto;
            width: auto !important;
          }
        }
      }

      &-header-text {
        display: flex;
      }

      &-content {
        color: #7a7a7a;
        margin: auto;
        padding: 0;
        line-height: normal;
        letter-spacing: 0.4px;
        text-align: center;

        hr {
          margin: 4px 30%;
          background-color: #ebebeb;
          height: 2px;
          border: 0;
        }

        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
</style>
